import React from 'react'
import { injectIntl } from 'react-intl'
import  ReactMarkdown from 'react-markdown';

class FormHeader extends React.Component {
  render(){
    const { formatMessage }  = this.props.intl

    return (
      <div className='form-header'>
         <ReactMarkdown source={this.props.title} className='form-header-center'/>
      </div>
    );
  }

};

export default injectIntl(FormHeader)
